/**
 * Amani Premium Product Page Lightbox Modal JS
 */
document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("product-media-modal");
  const modalActiveImg = document.getElementById("modal-active-image");
  const galleryItems = document.querySelectorAll(".product-gallery-item");
  const thumbBtns = document.querySelectorAll(".modal-thumb-btn");
  
  const closeBtn = document.getElementById("product-media-modal-close");
  const prevBtn = document.getElementById("modal-prev-btn");
  const nextBtn = document.getElementById("modal-next-btn");

  if (!modal || !modalActiveImg) return;

  let currentIndex = 0;
  const totalMedia = thumbBtns.length;

  // 1. OPEN MODAL
  galleryItems.forEach(item => {
    item.addEventListener("click", function () {
      // Do nothing on phone / tablet viewports
      if (window.innerWidth <= 768) {
        return;
      }
      const index = parseInt(this.getAttribute("data-index")) || 0;
      openModal(index);
    });
  });

  function openModal(index) {
    currentIndex = index;
    modal.classList.add("is-open");
    document.body.style.overflow = "hidden"; // Lock background body scroll
    updateActiveMedia(currentIndex);
    
    // Attach keyboard event listeners
    document.addEventListener("keydown", handleKeyboardNav);
  }

  // 2. CLOSE MODAL
  function closeModal() {
    modal.classList.remove("is-open");
    document.body.style.overflow = ""; // Restore background body scroll
    modalActiveImg.src = ""; // Clear source to stop media bandwidth when closed
    
    // Remove keyboard event listeners
    document.removeEventListener("keydown", handleKeyboardNav);
  }

  if (closeBtn) closeBtn.addEventListener("click", closeModal);

  // Close modal when clicking dark backdrop space (clicking main col but not on image)
  const mainCol = document.querySelector(".modal-main-image-col");
  if (mainCol) {
    mainCol.addEventListener("click", function (e) {
      if (e.target === this || e.target === document.querySelector(".modal-main-image-wrapper")) {
        closeModal();
      }
    });
  }

  // 3. THUMBNAIL CLICKING
  thumbBtns.forEach(btn => {
    btn.addEventListener("click", function () {
      const index = parseInt(this.getAttribute("data-index")) || 0;
      updateActiveMedia(index);
    });
  });

  // 4. NAVIGATION ACTIONS
  function showNext() {
    let nextIdx = currentIndex + 1;
    if (nextIdx >= totalMedia) nextIdx = 0; // Infinite loop wrap-around
    updateActiveMedia(nextIdx);
  }

  function showPrev() {
    let prevIdx = currentIndex - 1;
    if (prevIdx < 0) prevIdx = totalMedia - 1; // Infinite loop wrap-around
    updateActiveMedia(prevIdx);
  }

  if (nextBtn) nextBtn.addEventListener("click", showNext);
  if (prevBtn) prevBtn.addEventListener("click", showPrev);

  // 5. UPDATE ACTIVE IMAGE AND STYLES
  function updateActiveMedia(index) {
    currentIndex = index;

    // Grab the source directly from the gallery item if available
    const clickedItem = galleryItems[index];
    let fullSrc = "";
    
    if (clickedItem) {
      fullSrc = clickedItem.getAttribute("data-full-src");
    }

    // Fallback: If not on the gallery item, look for the thumbnail button
    const activeBtn = Array.from(thumbBtns).find(btn => parseInt(btn.getAttribute("data-index")) === index);
    if (!fullSrc && activeBtn) {
      fullSrc = activeBtn.getAttribute("data-full-src");
    }

    if (!fullSrc) return; // Absolutely nothing to show

    // Fade out active image
    modalActiveImg.style.opacity = "0";

    // Set source and fade in upon load
    const tempImg = new Image();
    tempImg.onload = function () {
      modalActiveImg.src = fullSrc;
      modalActiveImg.style.opacity = "1";
    };
    tempImg.src = fullSrc;

    // Toggle active classes on thumb buttons (safely if they exist)
    thumbBtns.forEach(btn => btn.classList.remove("active"));
    if (activeBtn) {
      activeBtn.classList.add("active");
      
      // Smooth scroll the active thumbnail into view
      activeBtn.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest"
      });
    }
  }

  // 6. KEYBOARD CONTROLS
  function handleKeyboardNav(e) {
    if (e.key === "Escape") {
      closeModal();
    } else if (e.key === "ArrowRight") {
      showNext();
    } else if (e.key === "ArrowLeft") {
      showPrev();
    }
  }
});
